angular.module('dnecom')
    .directive('productHref', ["$parse", function($parse) {
        function createUrl(store, product) {
            var url = window.location.protocol + "//" + store.subdomain + "." + window.ies.domain;

            if (store.domain) {
                url = 'http://' + store.domain;
            }

            if (product.slug) {
                return url + Routing.generate('stores_fe_product_slug', {
                        productSlug: product.slug,
                        hash: product.hash
                    });
            } else {
                return url + Routing.generate('stores_fe_product', {
                        productId: product.id,
                        hash: product.hash
                    });
            }
        }

        return {
            link: function(scope, element, attrs) {
                var context = $parse(attrs.productHref)(scope);

                element.attr('href', createUrl(context.store, context.product));
            }
        }
    }]);
